import React from "react"
import styled from "styled-components"
import { Quote } from "../../atoms/text"
import { Settings } from "../../../styles/theme"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Grid } from "../../atoms/grid"

const Quotestyle = styled.div`
  position: relative;
  background: ${props => (props.grey ? "#fafafa" : "white")};
  margin: 0 0 2rem;
  div {
    p {
      padding-bottom: 1rem;
      color: ${Settings.primaryColor};
    }
    h6 {
      text-align: right;
      margin: 0;
      b {
        color: ${Settings.secondaryColor};
      }
    }
  }
  > div {
    > div {
      > div {
        padding: 2rem;
        &:not(:first-of-type) {
          border-left: 1px solid rgba(0, 0, 0, 0.2);
          position: relative;
          hr {
            display: none;
          }
          @media screen and (max-width: ${Settings.sizeM}) {
            border-left: none;
            hr {
              display: block;
              position: absolute;
              top: -6rem;
              width: 90%;
            }
          }
        }
      }
    }
  }
`

export const Quotes = ({ data }) => (
  <Quotestyle grey={data.nestedContent.length <= 2 ? true : false}>
    <div className="constraint">
      <Grid>
        {data.nestedContent
          ? data.nestedContent.map((quote, i) => (
              <Quote key={i}>
                {i !== 0 ? <hr /> : ""}
                {documentToReactComponents(quote.content.json)}
              </Quote>
            ))
          : ""}
      </Grid>
    </div>
  </Quotestyle>
)
